export const colors = {
  primary: {
    50: '#f0f9f4',
    100: '#dcf2e3',
    200: '#bce4cb',
    300: '#8fcea8',
    400: '#5cb07e',
    500: '#38915c', // Main dark green from logo
    600: '#2a7349', // Darker shade for MM letters
    700: '#235b3c',
    800: '#1f4a33',
    900: '#1a3d2a',
    950: '#0d2116',
  },
  secondary: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ade80',
    500: '#22c55e', // Green for upward trends
    600: '#16a34a',
    700: '#15803d',
    800: '#166534',
    900: '#14532d',
    950: '#052e16',
  },
  danger: {
    50: '#fef2f2',
    100: '#fee2e2',
    200: '#fecaca',
    300: '#fca5a5',
    400: '#f87171',
    500: '#ef4444', // Red for downward trends
    600: '#dc2626',
    700: '#b91c1c',
    800: '#991b1b',
    900: '#7f1d1d',
    950: '#450a0a',
  },
  gray: {
    200: '#e5e7eb', // Light gray for borders and dividers
  },
};

